.left {
  display: inline-flex;
}
.right {
  display: inline-flex;
  margin-left: auto;
  align-items: center;
}

.left > *,
.right > * {
  margin-left: 8px;
  margin-right: 8px;
}

.filterForm {
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.filterFields {
  display: flex;
  flex-wrap: wrap;
}

.filterButtons {
  display: flex;
  flex-direction: row-reverse;
}

.filterRow {
  display: flex;
  width: 100%;
}

.filter_group {
  flex: 1 0 calc(100% / 6 - 15px);
}

.filter_group + .filter_group {
  margin-left: 15px;
}

.filter_group .label {
  display: block;
  font-size: 0.7rem;
  margin-bottom: 2px;
}

.filterInput {
  min-height: inherit;
  margin-bottom: 0.8rem;
}

.filters .filter_group .filterInput {
  margin: 0;
}

.filters .filterSelect {
  width: 100px;
}

.filters .filterText,
.filters .filterNumber {
  min-height: 38px;
}
.filters .filterText input,
.filters .filterNumber input {
  min-height: 38px;
}

.mainFilterContent {
  display: flex;
  width: 100%;
  z-index: 10;
  padding-top: 8px;
  padding-bottom: 8px;
}

.filterDropdownButton {
  cursor: pointer;
  transition: 0.3s;
  border: 2px solid var(--primary-60);
  border-radius: 64px;
  background-color: var(--primary-60);
  color: var(--color-ffffff);
  padding: 5px 12px;
  margin: 2px;
  font-weight: bold;
  display: inline-flex;
  font-family: Quicksand, sans-serif;
  font-size: 1rem;
  align-items: center;
  position: relative;
}

.filterDropdownPanel {
  overflow: hidden;
  padding: 0 15px;
  max-height: 0;
  border-radius: 20px;
}

.open {
  position: absolute;
  overflow: visible;
  padding: 15px;
  max-height: 666px;
  width: 400px;
  border: 2px solid var(--primary-60);
  background-color: var(--color-ffffff);
  margin: 60px 5px;
  z-index: 999;
}
